// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.photos.RentalManagerUserPropertyPhotoV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyPhotoCaptionV2RequestDto,
  UserPropertyPhotoDeleteV2RequestDto,
  UserPropertyPhotoRankV2RequestDto,
} from '../..';

export const RentalManagerUserPropertyPhotoV2WebApiHandler_caption_Path = '/api/web/v2/users/properties/photos/caption';

/**
 * Update a photo caption
 */
export const RentalManagerUserPropertyPhotoV2WebApiHandler_caption = (
  postData: UserPropertyPhotoCaptionV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyPhotoCaptionV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyPhotoV2WebApiHandler_caption_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyPhotoV2WebApiHandler_delete_Path = '/api/web/v2/users/properties/photos/delete';

/**
 * Delete a property photo
 */
export const RentalManagerUserPropertyPhotoV2WebApiHandler_delete = (
  postData: UserPropertyPhotoDeleteV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyPhotoDeleteV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyPhotoV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyPhotoV2WebApiHandler_rank_Path = '/api/web/v2/users/properties/photos/rank';

/**
 * Update the rank of photos
 */
export const RentalManagerUserPropertyPhotoV2WebApiHandler_rank = (
  postData: UserPropertyPhotoRankV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyPhotoRankV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyPhotoV2WebApiHandler_rank_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
